import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import React, { FC, useCallback } from 'react';
import { useStyles } from './OptionCard.styles';
import { Option } from '../Option';

interface OptionCardProps extends Option {
  onSelect: (value: number) => void;
  isActive?: boolean;
}
export const OptionCard: FC<OptionCardProps> = ({
  value,
  label,
  subLabel,
  onSelect,
  isActive,
  disabled,
}) => {
  const { classes } = useStyles();

  const onClickHandler = useCallback(() => onSelect(value), [onSelect, value]);

  return (
    <Box
      onClick={onClickHandler}
      className={classNames(classes.root, {
        [classes.disabled]: disabled,
        [classes.active]: isActive,
        [classes.withoutSubLabel]: !subLabel,
      })}
    >
      <Typography>{label}</Typography>
      {subLabel && <Typography variant="subtitle2">{subLabel}</Typography>}
    </Box>
  );
};
